<section *ngIf="collectionSize > 0 || collectionSize != null">
    <ngb-pagination class="pagination pull-right" [rotate]="true" [collectionSize]="collectionSize"
        [pageSize]="pageSize" [maxSize]="3" [(page)]="currentPage">
    </ngb-pagination>
</section>